// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3I3KA","sendOtp":"AuthorizeToLogin_sendOtp__3gf3J"};